import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import { coreDefaultModels } from '../../CORE/src/front/AppInitializer/coreDefaultModels'
import { fixed_holidays } from './fixed_holidays'
import { yhc_by_zipcodes } from './yhc_by_zipcodes'
import { yhc_estimate_form } from './yhc_estimate_form'
import { yhc_kazai_delivery_peak_season_rules } from './yhc_kazai_delivery_peak_season_rules'
import { yhc_kazai_kaguido_destination_options_and_prices } from './yhc_kazai_kaguido_destination_options_and_prices'
import { yhc_kazai_kaguido_destination_questions } from './yhc_kazai_kaguido_destination_questions'
import { yhc_kazai_option_services } from './yhc_kazai_option_services'
import { yhc_kazai_option_services_kazais } from './yhc_kazai_option_services_kazais'
import { yhc_kazai_type_size_options } from './yhc_kazai_type_size_options'
import { yhc_kazai_types } from './yhc_kazai_types'
import { yhc_kazai_types_sub_categories } from './yhc_kazai_types_sub_categories'
import { yhc_master_versions } from './yhc_master_versions'
import { yhc_masters } from './yhc_masters'
import { yhc_offices } from './yhc_offices'
import { yhc_options } from './yhc_options'
import { yhc_pref_from_to_infos } from './yhc_pref_from_to_infos'
import { yhc_regular_working_days } from './yhc_regular_working_days'
import { yhc_service_level_feedbacks } from './yhc_service_level_feedbacks'
import { yhc_service_level_notices } from './yhc_service_level_notices'
import { yhc_service_level_revisions } from './yhc_service_level_revisions'
import { yhc_special_lead_times } from './yhc_special_lead_times'

const models = {
  ...coreDefaultModels,
  fixed_holidays,
  yhc_by_zipcodes,
  yhc_estimate_form,
  yhc_kazai_delivery_peak_season_rules,
  yhc_kazai_kaguido_destination_options_and_prices,
  yhc_kazai_kaguido_destination_questions,
  yhc_kazai_option_services,
  yhc_kazai_option_services_kazais,
  yhc_kazai_type_size_options,
  yhc_kazai_types,
  yhc_kazai_types_sub_categories,
  yhc_master_versions,
  yhc_masters,
  yhc_offices,
  yhc_options,
  yhc_pref_from_to_infos,
  yhc_regular_working_days,
  yhc_service_level_feedbacks,
  yhc_service_level_notices,
  yhc_service_level_revisions,
  yhc_special_lead_times,
  // add here the project model definitions
}
export type TModelName = keyof typeof models
export default models as { [modelName: string]: ModelDef }
